export enum FaxState {
  None = 0,
  Success = 1,
  Pending = 2,
  Failed = 3,
}
